/**
 * Die Datums-Umrechnungen, die sich alle Entitäten teilen — aus
 * `sync-entity-configs.ts` gezogen (2026-09-05, siehe
 * `.claude/tasks/large-files.md`).
 */

/**
 * Convert a startDate to an ISO string for Supabase.
 * If startTime is set (e.g. "17:00"), combine date + time in local timezone.
 * Otherwise use noon UTC so the calendar date survives timezone conversion.
 */
export function dateToISO(date: Date | null, time: string | null): string | null {
  if (!date) return null
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  if (time) {
    const [h, min] = time.split(':').map(Number)
    const local = new Date(date)
    local.setHours(h, min, 0, 0)
    return local.toISOString()
  }
  return `${y}-${m}-${d}T12:00:00.000Z`
}

/** @deprecated Use dateToISO instead */
export function startDateToISO(date: Date | null, startTime: string | null): string | null {
  return dateToISO(date, startTime)
}

/** Parse a 'YYYY-MM-DD' DATE string into a LOCAL-midnight Date (no UTC shift). */
export function parseLocalDate(s: string): Date {
  const [y, m, d] = s.split('-').map(Number)
  return new Date(y, (m ?? 1) - 1, d ?? 1)
}

/** Format a Date as a local 'YYYY-MM-DD' string for a Postgres DATE column. */
export function toDateString(d: Date): string {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}
